// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__108LN","clinicsSelect":"TableHeading_clinicsSelect__3DEmp"};